import { withInstall } from '@ll-plus/utils'

import CustomSorter from './src/custom-sorter.vue'

export const LlCustomSorter = withInstall(CustomSorter)
export default LlCustomSorter
export * from './src/custom-sorter'

declare module 'vue' {
  export interface GlobalComponents {
    LlCustomSorter: typeof CustomSorter
  }
}
